import React from "react";
import { Progress } from "@shared/ui/progress";
import { ProgressItemProps } from "../../types";
import { progressColors } from "../../utils";

export const ProgressItem: React.FC<ProgressItemProps> = ({
  label,
  value,
  maxValue,
  percentage,
  icon: Icon,
  iconColor = "text-muted-foreground",
  subtitle,
  showPercentage = true,
  showValue = true,
  variant = "default",
}) => {
  const displayPercentage =
    percentage ?? (maxValue ? (value / maxValue) * 100 : value);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {Icon && <Icon className={`h-5 w-5 ${iconColor}`} />}
          <div>
            <p className="font-medium text-sm">{label}</p>
            {subtitle && (
              <p className="text-xs text-muted-foreground">{subtitle}</p>
            )}
          </div>
        </div>

        <div className="text-right">
          {showValue && (
            <span className={`text-sm font-medium ${progressColors[variant]}`}>
              {typeof value === "number" ? value.toLocaleString() : value}
            </span>
          )}
          {showPercentage && (
            <span className="text-sm font-medium text-muted-foreground ml-2">
              {/* ({displayPercentage.toFixed(1)}%) */}
            </span>
          )}
        </div>
      </div>

      <Progress value={displayPercentage} className="h-2" />
    </div>
  );
};
